import { createFileRoute } from "@tanstack/react-router";
import { AssetWizard } from "@/features/assets/AssetWizard";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { canCreateAsset, canCreateAssetFromGRN } from "@/lib/roles";

export const Route = createFileRoute("/_authenticated/assets/new")({
  validateSearch: (search: Record<string, unknown>) => ({
    parent_asset_id: (search.parent_asset_id as string) || undefined,
  }),
  component: NewAssetGate,
});

function NewAssetGate() {
  const { parent_asset_id } = Route.useSearch();
  const { data } = useCurrentUser();
  if (!data) return null;
  const roles = data.roles;
  const hasGrnPrefill =
    typeof window !== "undefined" && !!sessionStorage.getItem("grn_asset_prefill");
  const allowed =
    canCreateAsset(roles) || (canCreateAssetFromGRN(roles) && hasGrnPrefill);

  if (!allowed) {
    return (
      <div className="mx-auto max-w-xl rounded-lg border bg-card p-6">
        <h1 className="text-lg font-semibold">Permission required</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          You do not have permission to create assets directly. Purchase /
          Stores users can create assets only from the GRN → "Save &amp;
          Create Asset" flow.
        </p>
      </div>
    );
  }
  return <AssetWizard mode="create" defaultParentAssetId={parent_asset_id} />;
}
